const selectors = {
  announcement: '#shopify-section-announcement',
  transparent: 'data-header-transparent',
  header: '[data-header-wrapper] header',
};

const classes = {
  stuck: 'js__header__stuck',
  stuckAnimated: 'js__header__stuck--animated',
  triggerAnimation: 'js__header__stuck--trigger-animation',
  stuckBackdrop: 'js__header__stuck__backdrop',
};

let sections = {};

class Sticky {
  constructor(el) {
    this.wrapper = el;
    this.type = this.wrapper.dataset.headerSticky;
    this.transparent = this.wrapper.dataset.headerTransparent;
    this.sticks = this.type === 'sticky';
    this.animated = this.type === 'directional';
    this.currentlyStuck = false;
    this.cls = this.wrapper.classList;
    const announcementEl = document.querySelector(selectors.announcement);
    const announcementHeight = announcementEl ? announcementEl.clientHeight : 0;
    const headerHeight = document.querySelector(selectors.header).clientHeight;
    this.blur = headerHeight + announcementHeight;
    this.stickDown = headerHeight + announcementHeight;
    this.stickUp = announcementHeight;
    if (this.wrapper.getAttribute(selectors.transparent) !== 'false') {
      this.blur = announcementHeight;
    }
    if (this.sticks) {
      this.stickDown = announcementHeight;
      this.scrollDownInit();
    }
    this.listen();
  }

  unload() {
    document.removeEventListener('theme:scroll', this.listen);
    document.removeEventListener('theme:scroll:up', this.scrollUpDirectional);
    document.removeEventListener('theme:scroll:down', this.scrollDownDirectional);
  }

  listen() {
    if (this.sticks || this.animated) {
      document.addEventListener('theme:scroll', (e) => {
        if (e.detail.down) {
          if (!this.currentlyStuck && e.detail.position > this.stickDown) {
            this.stickSimple();
          }
          if (!this.currentlyBlurred && e.detail.position > this.blur) {
            this.addBlur();
          }
        } else {
          if (e.detail.position <= this.stickUp) {
            this.unstickSimple();
          }
          if (e.detail.position <= this.blur) {
            this.removeBlur();
          }
        }
      });
    }
    if (this.animated) {
      document.addEventListener('theme:scroll:up', this.scrollUpDirectional.bind(this));
      document.addEventListener('theme:scroll:down', this.scrollDownDirectional.bind(this));
    }
  }

  stickSimple() {
    if (this.animated) {
      this.cls.add(classes.stuckAnimated);
    }
    this.cls.add(classes.stuck);
    this.wrapper.setAttribute(selectors.transparent, false);
    this.currentlyStuck = true;
  }

  unstickSimple() {
    this.cls.remove(classes.stuck);
    this.wrapper.setAttribute(selectors.transparent, this.transparent);
    if (this.animated) {
      this.cls.remove(classes.stuckAnimated);
    }
    this.currentlyStuck = false;
  }

  scrollDownInit() {
    if (window.scrollY > this.stickDown) {
      this.stickSimple();
    }
    if (window.scrollY > this.blur) {
      this.addBlur();
    }
  }

  stickDirectional() {
    this.cls.add(classes.triggerAnimation);
  }

  unstickDirectional() {
    this.cls.remove(classes.triggerAnimation);
  }

  scrollDownDirectional() {
    this.unstickDirectional();
  }

  scrollUpDirectional() {
    if (window.scrollY <= this.stickDown) {
      this.unstickDirectional();
    } else {
      this.stickDirectional();
    }
  }

  addBlur() {
    this.cls.add(classes.stuckBackdrop);
    this.currentlyBlurred = true;
  }

  removeBlur() {
    this.cls.remove(classes.stuckBackdrop);
    this.currentlyBlurred = false;
  }
}

const stickyHeader = {
  onLoad() {
    sections = new Sticky(this.container);
  },
  onUnload: function () {
    if (typeof sections.unload === 'function') {
      sections.unload();
    }
  },
};

export default stickyHeader;
